import React, {useState} from 'react';
import {Button, Dropdown, DropdownButton, Modal, Spinner} from "react-bootstrap";
import {PERIOD_MONTH, PERIOD_YEAR, PLANS, PLANS_ID} from "../../constants/plans";
import {QUARTERLY} from "../../constants/plans/pro-student";
import {ToolTip} from "../ProPlans/PlanCards";
import {upgradeAccount} from "../../services/manage";
import {ErrorBox} from 'components/ErrorBox/ErrorBox';

const getPriceLabel = (plan, period) =>
  plan.prices[period] && `${plan.prices[period].ccy || '$'} ${plan.prices[period].value}`

const FeatureList = ({planId}) => {
  return <>
    {planId === PLANS.PRO_U.id && <>
      <div className="flex pt-3 ms-3 align-items-center bold">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Add up to two more team
        members <ToolTip text="Add more team members for $8 each"/>
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Upload more than 75mb files
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Upload more than {PLANS.PRO.projectLimit} projects
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> All Solo & Tiny plan features
      </div>
    </>}
    {planId === PLANS.PRO.id && <>
      <div className="flex pt-3 ms-3 align-items-center bold">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Connect your custom domain
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Upload more than {PLANS.TINY.fileSizeLimit}mb files
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Upload more than 1 project
      </div>
      <div className="flex pt-2 ms-3 align-items-center">
        <img className="me-2" height="15px" width="15px" alt="check" src="/check.png"/> Edit your content
      </div>
      <div className="flex pt-2 ms-3 align-items-center opacity-25">
        <img className="me-2" height="15px" width="15px" alt="check" src="/assets/icons/x.png"/> Add team members
      </div>
    </>}
    <div className="mt-3 font-16 ms-3">
      <a className="color-purple" href="https://tiiny.host/pricing" target="_blank">And more →</a>
    </div>
  </>
}

const SuccessView = ({history}) => <div>
  <div>
    <div className="color-purple mb-2 font-22">Account upgraded</div>
    <img className="me-3" height="25px" width="25px" alt="check" src="/check.png"/>
    Your account has been successfully upgraded.
  </div>
  <Button className="float-right mt-1" onClick={() => history.push('/')}>Done</Button>
</div>

const PlansDropdown = ({defaultPlanId, onPlanSelected}) => {
  const [plan, setPlan] = useState(defaultPlanId);

  const onChange = (eK, e) => {
    setPlan(e.target.value)

    if (onPlanSelected)
      onPlanSelected(e.target.value)
  }

  return <DropdownButton
    title={PLANS_ID[plan]?.label}
    className="d-inline-block ms-2"
    value={plan} variant="outline-primary"
    onSelect={onChange}
  >
    <Dropdown.Item as="option" key={PLANS.PRO.id} value={PLANS.PRO.id}>{PLANS.PRO.label}</Dropdown.Item>
    <Dropdown.Item as="option" key={PLANS.PRO_U.id} value={PLANS.PRO_U.id}>{PLANS.PRO_U.label}</Dropdown.Item>
  </DropdownButton>
}

const RequestView = ({isLoading, currentPlanId, defaultPlan, periodProp, onConfirm}) => {
  const [period, setPeriod] = useState(periodProp)
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan)

  const onPlanChange = (plan) => setSelectedPlan(PLANS_ID[plan])

  return <>
    <h4 className="mb-2 bold color-purple-2">
      Upgrade to {currentPlanId === PLANS.TINY.id ? <PlansDropdown defaultPlanId={defaultPlan.id} onPlanSelected={onPlanChange}/> : 'Pro'}
    </h4>
    <div className="mt-3">To:</div>
    <FeatureList
      planId={selectedPlan.id}
    />
    <div
      className="d-block"
    >
      <div className="p-4 flex">
        {selectedPlan.prices.monthly && <Button
          className="flex-grow-1"
          variant={period === 'monthly' ? 'outline-primary' : 'outline-secondary'}
          onClick={() => setPeriod(PERIOD_MONTH)}
        >
          <div className="price">
            <h6>Monthly</h6>
            <div>
              {getPriceLabel(selectedPlan, PERIOD_MONTH)} <span className="price-period">/ month</span>
            </div>
          </div>
        </Button>}
        {selectedPlan.prices.yearly && <Button
          className="flex-grow-1 ms-2"
          variant={period === PERIOD_YEAR ? 'outline-primary' : 'outline-secondary'}
          onClick={() => setPeriod(PERIOD_YEAR)}
        >
          <div className="price">
            <h6>Yearly</h6>
            <div>
              {getPriceLabel(selectedPlan, PERIOD_YEAR)} <span className="price-period">/ year</span>
            </div>
            {[PLANS.PRO.id, PLANS.PRO_U.id].includes(selectedPlan.id) &&
            <div className="price-period mt-1">(2 months free)</div>}
          </div>
        </Button>}
        {selectedPlan.prices[QUARTERLY] && <Button
          className="flex-grow-1 ms-2"
          variant="outline-primary"
        >
          <div className="price">
            <h6>Quarterly</h6>
            <div>${selectedPlan.prices[QUARTERLY].value} <span className="price-period">/ 3-months</span></div>
          </div>
        </Button>}
      </div>
      <p>
        You will be
        billed <b>{getPriceLabel(selectedPlan, period)} {selectedPlan === 'PRO_STUDENT' ? 'every' : ''} {period.toLowerCase()}</b> on
        a pro rata basis.<br/>
        <span className="op-6">We will automatically charge your current payment method.</span>
      </p>
    </div>
    <div>
      <Button
        className="ms-auto me-auto mt-2 float-right"
        type="submit"
        disabled={isLoading}
        onClick={() => onConfirm({plan: `${getPriceLabel(selectedPlan, period)} ${period}`, period})}
      >
        Confirm
        {isLoading && <Spinner className="ms-2" animation="border" size="sm"/>}
      </Button>
    </div>
  </>
}

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILED = 'FAILED';

const UpgradePayModal = ({
  history,
  email,
  show,
  onHide,
  currentPlanId = PLANS.PRO.id,
  periodProp = "monthly",
  defaultPlan
}) => {
  const [stage, setStage] = useState(REQUEST);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const selectedPlan = PLANS_ID[defaultPlan] || (currentPlanId === PLANS.TINY.id ? PLANS.PRO : PLANS.PRO_U);

  const onConfirm = ({plan, period}) => {
    setIsLoading(true);
    upgradeAccount({
      email,
      plan,
      priceId: selectedPlan?.prices?.[period]?.id,
      paddleId: selectedPlan?.prices?.[period]?.paddleId,
      productId: selectedPlan?.id
    })
      .then(() => {
        setIsLoading(false)
        setStage(SUCCESS);
      })
      .catch((e) => {
        setIsLoading(false)
        setStage(FAILED)
        setErrorMsg(e.message)
      })
  }

  return <Modal
    show={show}
    onHide={onHide}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <div className="p-3">
      {stage === REQUEST && <RequestView
        isLoading={isLoading}
        currentPlanId={currentPlanId}
        defaultPlan={selectedPlan}
        periodProp={periodProp}
        onConfirm={onConfirm}
      />}
      {stage === SUCCESS && <SuccessView history={history}/>}
      {stage === FAILED &&
      <ErrorBox
        message={errorMsg || "Sorry, unable to upgrade your account"}
        onClick={() => {
          setStage(REQUEST)
          setErrorMsg(undefined)
        }}
      />}
    </div>
  </Modal>
};

export default UpgradePayModal;
